module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-sun-10f7935f.svg";